import { render, staticRenderFns } from "./staticitem.vue?vue&type=template&id=76513282"
import script from "./staticitem.vue?vue&type=script&lang=ts"
export * from "./staticitem.vue?vue&type=script&lang=ts"
import style0 from "./staticitem.vue?vue&type=style&index=0&id=76513282&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports